import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_model",
  ref: "addModelModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_model_header"
}
const _hoisted_5 = {
  key: 0,
  class: "fw-bolder"
}
const _hoisted_6 = {
  key: 1,
  class: "fw-bolder"
}
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_10 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_model_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_model_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_model_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_11 = { class: "row d-flex flex-wrap align-items-end mb-7" }
const _hoisted_12 = { class: "col-md-6 form-group" }
const _hoisted_13 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_14 = { class: "col-md-6 form-group d-flex mb-1" }
const _hoisted_15 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_16 = { class: "row mb-7" }
const _hoisted_17 = { class: "col-md-6 form-group" }
const _hoisted_18 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_19 = { class: "col-md-6 form-group" }
const _hoisted_20 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_21 = { class: "row mb-7" }
const _hoisted_22 = { class: "col-md-6 form-group" }
const _hoisted_23 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_24 = { class: "col-md-6 form-group" }
const _hoisted_25 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_26 = { class: "row mb-7" }
const _hoisted_27 = { class: "col-md-6 form-group" }
const _hoisted_28 = { class: "col-md-6 form-group" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle ms-1 fs-7" }, null, -1)
const _hoisted_30 = { class: "form-group mb-7" }
const _hoisted_31 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_32 = { class: "modal-footer flex-center" }
const _hoisted_33 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_34 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_35 = { class: "indicator-label" }
const _hoisted_36 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_37 = { class: "indicator-progress" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.id == 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.t("common.add") + _ctx.t("capabilityModel.capabilityModels")), 1))
            : (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_ctx.t("common.edit") + _ctx.t("capabilityModel.capabilityModels")), 1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("capabilityModel.name")), 1),
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("capabilityModel.status")), 1),
                    _createVNode(_component_el_form_item, {
                      prop: "status",
                      class: "form-item-status"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.formData.status,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.status) = $event)),
                          "active-value": 10,
                          "inactive-value": 25
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("capabilityModel.shortKey")), 1),
                    _createVNode(_component_el_form_item, { prop: "short_key" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.short_key,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.short_key) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("capabilityModel.capabilityModelGroup")), 1),
                    _createVNode(_component_el_form_item, { prop: "group_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.group_id,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.group_id) = $event)),
                          disabled: "",
                          filterable: "",
                          style: {"width":"100%"},
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelGroupOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("capabilityModel.layout")), 1),
                    _createVNode(_component_el_form_item, { prop: "layout" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.layout,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.layout) = $event)),
                          clearable: "",
                          filterable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"},
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layoutOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("capabilityModel.sort")), 1),
                    _createVNode(_component_el_form_item, { prop: "sort" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.sort,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.sort) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["fs-6 fw-bold mb-2", {
                      required: !(
                        _ctx.formData.layout == 'text' ||
                        _ctx.formData.layout == 'range' ||
                        _ctx.formData.layout == 'switch'
                      ),
                    }])
                    }, _toDisplayString(_ctx.t("capabilityModel.valueSourceType")), 3),
                    _createVNode(_component_el_form_item, { prop: "value_source_type" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.value_source_type,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.value_source_type) = $event)),
                          clearable: "",
                          filterable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"},
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _ctx.t('capabilityModel.static'),
                              value: "static"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.t('capabilityModel.remote'),
                              value: "remote"
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["fs-6 fw-bold mb-2", {
                      required: !(
                        _ctx.formData.layout == 'text' ||
                        _ctx.formData.layout == 'range' ||
                        _ctx.formData.layout == 'switch'
                      ),
                    }])
                    }, _toDisplayString(_ctx.t("capabilityModel.valueSource")), 3),
                    (_ctx.formData.value_source_type == 'static')
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          class: "box-item",
                          content: "Value Source只能填id和short_key",
                          placement: "top",
                          effect: "light"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, { prop: "value_source" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.value_source,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.value_source) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("capabilityModel.description")), 1),
                  _createVNode(_component_el_form_item, { prop: "note" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.note,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.note) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_33, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
              ]),
              _createElementVNode("button", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_37, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_38
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}